import {
  Bell,
  Calendar,
  Gem,
  Globe,
  Sheet,
  type LucideIcon,
} from 'lucide-react'

export const SUPPORT_SECTIONS = [
  { slug: 'events', icon: Calendar },
  { slug: 'loot', icon: Gem },
  { slug: 'notifications', icon: Bell },
  { slug: 'spreadsheet', icon: Sheet },
  { slug: 'custom_domain', icon: Globe },
] as const

export type SupportSectionSlug = typeof SUPPORT_SECTIONS[number]['slug']

export const SUPPORT_SECTION_SLUGS: SupportSectionSlug[] = SUPPORT_SECTIONS.map(
  (section) => section.slug,
)

export const isSupportSectionSlug = (
  value: string,
): value is SupportSectionSlug =>
  SUPPORT_SECTION_SLUGS.includes(value as SupportSectionSlug)

export const supportSectionIcon = (slug: SupportSectionSlug): LucideIcon =>
  SUPPORT_SECTIONS.find((section) => section.slug === slug)?.icon ?? Globe
